import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from '../api/alms-api';
let _apiClient: ApiClient;
const _logger = Log.create('Login-Service');
export class LoginService {
    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestAccessTokenAsync(userName: string, password: string, googleCaptchaToken?: string) {
        const parsedUrl = new URL(window.location.href);
        if (parsedUrl.port === '' && (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:')) {
            parsedUrl.port = '3000';
        }
        let grantType = userName.startsWith('ADVANCITY') ? 'grant_type=advlogin&' : 'grant_type=password&'
        let formData = '';
        formData += 'client_id=api&';
        formData += grantType;
        formData += 'username=' + userName + '&';
        formData += 'password=' + encodeURIComponent(password) + '&';
        formData += 'googleCaptchaToken=' + googleCaptchaToken + '&';
        formData += 'address=' + parsedUrl.hostname + '&';
        formData += 'port=' + parsedUrl.port;

        return fetch(window.appSettings.AUTH_URL + '/connect/token', {
            method: 'POST',
            body: formData,
            headers: {
                Accept: 'application/json',
                'Content-Type':
                    'application/x-www-form-urlencoded',
            },
        });
    }
    public async RequestAccessTokenByRefreshTokenAsync(refreshToken: string) {
        const parsedUrl = new URL(window.location.href);
        if (parsedUrl.port === '' && parsedUrl.protocol === 'http:') {
            parsedUrl.port = '3000';
        } else if (parsedUrl.port === '' && parsedUrl.protocol === 'https:') {
            parsedUrl.port = '3000';
        }
        let formData = '';
        formData += 'client_id=api&';
        formData += 'grant_type=refresh_token&';
        formData += 'refresh_token=' + refreshToken;
        return fetch(window.appSettings.AUTH_URL + '/connect/token', {
            method: 'POST',
            body: formData,
            headers: {
                Accept: 'application/json',
                'Content-Type':
                    'application/x-www-form-urlencoded;charset=UTF-8',
            },
        });
    }
    public async AccessTokenValidate(accessToken: string) {
        const response = fetch(window.appSettings.AUTH_URL + '/connect/introspect', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + accessToken,
            },
        });
        const responseIsAuth = response.then((resp: Response) => {
            if (resp.status !== 200) return false;
            else return resp.json();
        })
            .then((value: any) => {
                return !!value.active;
            });
        return responseIsAuth;
    }
    public async DecrypTokenAsync(token: string) {
        const parsedUrl = new URL(window.location.href);
        return _apiClient.RequestAsync('POST', 'api/account/decryptoken',
            {
                Token: token,
                Host: parsedUrl.hostname,
                Port: parsedUrl.port
            }).then((result: any) => {
                return result;
            }).catch((response) => {
                return response;
            });
    }

    public async DecrypTokenObsAsync(token: string) {
        try {
            const response = await fetch(`${window.appSettings.AUTH_URL}/connect/fromExternal?token=${token}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            return response;
        } catch (error) {
            throw error;
        }
    }

    public async DecrypEdevletTokenAsync(token: string) {
        const parsedUrl = new URL(window.location.href);

        return _apiClient.RequestAsync('POST', 'api/account/decrypedevlettoken', {
            Token: token,
            Host: parsedUrl.hostname,
            Port: parsedUrl.port
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }
    public async ConnectToAlms(params?: any) {
        const parsedUrl = new URL(window.location.href);

        return _apiClient.RequestAsync('POST', 'api/account/ConnectWebToAlms', {
            host: parsedUrl.hostname,
            port: parsedUrl.port,
            scheme: parsedUrl.protocol,
            isReturnUrl: !!params?.isReturnUrl,
            returnType: params?.returnType ?? '',
            courseId: params?.courseId ?? '',
            classId: params?.classId ?? '',
            activityId: params?.activityId ?? '',
            enrollmentId: params?.enrollmentId ?? '',
            userName: params?.userName ?? "",
            password: params?.password ?? ""
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }
    public async ConnectToExamApp(params?: any) {
        const parsedUrl = new URL(window.location.href);

        return _apiClient.RequestAsync('POST', 'api/account/connectToExamApp', {
            host: parsedUrl.hostname,
            port: parsedUrl.port,
            id: params && params.id ? params.id : '',
            sessionId: params && params.sessionId ? params.sessionId : '',
            eId: params && params.eId ? params.eId : ''
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }
    public async MyForgotPasswordCheckUser(searchedUser: string) {
        const parsedUrl = new URL(window.location.href);
        const url: string = window.appSettings.API_URL;
        return _apiClient.RequestAsync('POST', 'api/account/myForgotPassword', {
            Adress: parsedUrl.hostname,
            Port: parsedUrl.port,
            Scheme: parsedUrl.protocol,
            SearchedUser: searchedUser
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async MyForgotPasswordQuestionAnswer(searchedUser: string, enteredText: string) {

        const parsedUrl = new URL(window.location.href);
        return _apiClient.RequestAsync('POST', 'api/account/myForgotPassQuestionAnswer', {
            Adress: parsedUrl.hostname,
            Port: parsedUrl.port,
            SearchedUser: searchedUser,
            typedText: enteredText
        }, '').then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async MyForgotPasswordCheckToken(token: string) {
        const parsedUrl = new URL(window.location.href);
        return _apiClient.RequestAsync('POST', 'api/account/myForgotPasswordCheckToken', {
            Adress: parsedUrl.hostname,
            Port: parsedUrl.port,
            Token: token
        }, '').then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async LoginAnnoucementData(organizationId: string) {
        const parsedUrl = new URL(window.location.href);
        if (parsedUrl.port === '' && parsedUrl.protocol === 'http:') {
            parsedUrl.port = '3000';
        }
        return _apiClient.RequestAsync('POST', '/api/announcement/announcements', {
            take: 100,
            skip: 0,
            items: [{
                contextType: 2,
                contextId: -1
            }],
            state: 1,
            address: parsedUrl.hostname,
            port: parsedUrl.port,
        }, '').then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async MyForgotPasswordSave(token: string, password: string) {
        const parsedUrl = new URL(window.location.href);
        return _apiClient.RequestAsync('POST', 'api/account/newPasswordSave', {
            Adress: parsedUrl.hostname,
            Port: parsedUrl.port,
            PasswordVerificationToken: token,
            Password: password
        }, '').then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async CheckVerificationCode(username: string, verificationCode: string) {
        const parsedUrl = new URL(window.location.href);
        return _apiClient.RequestAsync('POST', 'api/account/checkVerificationCode', {
            Address: parsedUrl.hostname,
            Port: parsedUrl.port,
            UserName: username,
            VerificationCode: verificationCode
        }, '').then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async VerificateUser(username: string, token: string) {
        const parsedUrl = new URL(window.location.href);
        return _apiClient.RequestAsync('POST', 'api/account/verificateUser', {
            Address: parsedUrl.hostname,
            Port: parsedUrl.port,
            UserName: username,
            Token: token
        }, '').then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }
}
